import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { AppStateService } from '../../../../services/app-state.service';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';

import { Subscription } from 'rxjs';
import { outputAst } from '@angular/compiler';

@Component({
  selector: 'app-assign-resources',
  templateUrl: './assign-resources.component.html',
  styleUrls: ['./assign-resources.component.scss']
})
export class AssignResourcesComponent implements OnInit, OnDestroy {

  @Input() applicationId: any;
  @Input() disabled: boolean = false;
  @Output() getData = new EventEmitter<any>();
  appDetails: any;

  resourcesData: any = null;
  resourcesDataCopy : any = null;
  resourceTypeMap = USER_MGMT_CNST.RESOURCE_TYPES_MAP;
  actionNameMapping:any = USER_MGMT_CNST.ACTION_NAME_MAPPING;

  searchApi!: string;
  searchWidget!:string;
  searchDashboard!:string;
  searchUrl!:string;

  resourceTypes: string[] = [];
  customerDetails: any;
  @Input() customerId: any;

  subscriptions : Subscription[] = [];
  @Input() applicationName: any;
  @Input() applicationListWithResources: any;

  constructor(
    private appState: AppStateService,
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private envService: EnvService,
    private router: Router,
  ) { }

  async ngOnInit() {
    this.customerDetails = this.appState.getCustomerData();
    this.appDetails = this.appState.getSelectedResourceDetails();

    if (!this.utilSrv.isObjectNotNullAndEmpty(this.appDetails)) {
      
      let appsListWithResources = this.applicationListWithResources;

      if (this.utilSrv.isObjectNotNullAndEmpty(appsListWithResources)) {
        let { response } = appsListWithResources;

        if (this.utilSrv.isObjectNotNullAndEmpty(response)) {

          let appInfo = Object.keys(response)
            .filter((appName: string) => this.applicationName === appName);

          if (appInfo.length > 0) {
            let appDetails = response[appInfo[0]];

            if (this.utilSrv.isObjectNotNullAndEmpty(appDetails)) {

              let modifiedAppDetails = {
                key : this.applicationName,
                value : appDetails
              }

              this.appDetails = modifiedAppDetails;
            }
          }
        }
      }
    }
    this.fetchData();
  }


  selectAll(type: string) {
    for(let resource of this.resourcesData[type]) {
      resource['isAssigned'] = true;
    }
    this.checkBoxCommon(type, -1);
  }

  clearAll(type: string) {
    for(let resource of this.resourcesData[type]) {
      resource['isAssigned'] = false;
    }
    this.checkBoxCommon(type, -1);
  }

  checkBoxCommon(resourceType: string, index: number = -1) {
    if(index != -1) {
      this.resourcesData[resourceType][index].isAssigned = !this.resourcesData[resourceType][index].isAssigned;
    }
    let customerId = !isNullOrUndefined(this.customerId)? this.customerId: this.appState.getCurrentCustomerId();
 
    let postData: {
      "customerId": any,
      "assignResources": any[],
      "deleteResources": any[],
      "customerDetailsJson": any
    } = {
      "customerId": null,
      "assignResources": [],
      "deleteResources": [],
      "customerDetailsJson": "{}"
    }
    
    if (!isNullOrUndefined(customerId)) {
    
      postData.customerId = customerId;
      
      let resources = this.getformatResourceData();
      
      postData.assignResources = this.getAssignedResource(resources.selectedResources, resources.previouslySelectedResource);
      postData.deleteResources = this.getDeletedResource(resources.selectedResources, resources.previouslySelectedResource);
      this.getData.emit(postData);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  fetchData() {   
    if (!isNullOrUndefined(this.applicationId)) {
      this.httpSrv.makeGetApiCall('FETCH_RESOURCES_BY_APPLICATION_ID', this.envService.baseUrl, { uriParams: { applicationId: this.applicationId } }).subscribe({
        next: (response: any) => {
          this.resourcesData = this.formatResponse(response['response']);          
          this.resourcesDataCopy = { ...this.resourcesData };
        },
        complete: () => {},
        error: () => {
          this.utilSrv.showToastMessage("Failed to fetch applications list", "error");
        }
      });     
    } else {
      console.log("Application id is null or undefined ", this.applicationId);
      this.utilSrv.showToastMessage("Unable to fetch resources for application", "error");
    }
  }

  formatResponse(data: any) {
    let resourceTypeDataMap: {
      "APIs": any[],
      "URLs": any[],
      "Dashboards": any[],
      "Widgets": any[]
    } = {
      "APIs": [],
      "URLs": [],
      "Dashboards": [],
      "Widgets": []
    };
    this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
    data.forEach((e: any) => {
      if (this.appDetails && this.appDetails['value'] && this.appDetails['value'][e.resourceTypeName]) {
        let filterData = this.appDetails['value'][e.resourceTypeName].find((r: any) => r.resourceId === e.resourceId && r.resourceActionName === e.resourceActionName);
        e['isAssigned'] = filterData ? true : false;
      } else {
        e['isAssigned'] = false;
      }
      resourceTypeDataMap[e.resourceTypeName as keyof typeof resourceTypeDataMap].push(e);
    });
    return resourceTypeDataMap;
  }

  assignOrUpdateResources() {

    let customerId = !isNullOrUndefined(this.customerId)? this.customerId: this.appState.getCurrentCustomerId();

    let postData: {
      "customerId": any,
      "assignResources": any[],
      "deleteResources": any[],
      "customerDetailsJson": any
    } = {
      "customerId": null,
      "assignResources": [],
      "deleteResources": [],
      "customerDetailsJson": "{}"
    }

    if (!isNullOrUndefined(customerId)) {

      postData.customerId = customerId;

      let resources = this.getformatResourceData();

      postData.assignResources = this.getAssignedResource(resources.selectedResources, resources.previouslySelectedResource);
      postData.deleteResources = this.getDeletedResource(resources.selectedResources, resources.previouslySelectedResource);
      
      if (postData.assignResources.length === 0 && postData.deleteResources.length === 0) {
        this.utilSrv.showToastMessage("No resources selected to assign / update", "error");
        return;
      } else {
        this.httpSrv.makePostApiCall('ASSIGN_OR_UPDATE_RESOURCES', postData, this.envService.baseUrl).subscribe({
          next: () => {
            this.utilSrv.showToastMessage("Resources updated successfully ", "success");
            this.navigateToCustomerView();
          },
          complete: () => {},
          error: () => {
            this.utilSrv.showToastMessage("Error in assigning/updating resources", "error");
          }
        });
      }
    }
  }

  getAssignedResource(selectedResources: any[], previouslySelectedResource: any[]){
    let assignedResource: any[] = [];
    selectedResources.forEach((e: any)=>{
       if(previouslySelectedResource.indexOf(e) == -1){
         assignedResource.push(e);
       }
    })
    return assignedResource;
  }

  getDeletedResource(selectedResources: any[], previouslySelectedResource: any[]){
    let deletedResource: any[] = [];
    previouslySelectedResource.forEach((e: any)=>{
       if(selectedResources.indexOf(e) == -1){
         deletedResource.push(e);
       }
    });

    return deletedResource;
  }

  getformatResourceData(){
    let selectedResources: any[] = [];
    let previouslySelectedResource: any[] = [];
    this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
    this.resourceTypes.forEach((type: any)=>{
      let selectedList: any[] = [];
      if(this.resourcesData && Object.keys(this.resourcesData).length !=0 && this.resourcesData[type]){
        let list = this.resourcesData[type].map((e: any) => {return {resourceActionId:e['resourceActionId'], isAssigned:e['isAssigned']}});
        let filteredList = list.filter((e: any)=> e['isAssigned'] === true);
        selectedList = filteredList.map((e: any)=> e['resourceActionId']);
      }

      let previouslySelectedList = [];
      if(this.appDetails && this.appDetails['value'] && Object.keys(this.appDetails['value']).length !=0 && this.appDetails['value'][type]){
        previouslySelectedList = this.appDetails['value'][type].map((e: any) => e['resourceActionId']);
      }
      selectedResources = selectedResources.concat(selectedList);
      previouslySelectedResource = previouslySelectedResource.concat(previouslySelectedList);
    });

    return {selectedResources, previouslySelectedResource};
  }

  navigateToCustomerView() {
    this.router.navigate(['um', 'customer', 'addCustomer'], {
      queryParamsHandling: 'merge'
    });
  }

  onResourceSearch(resourceType: string, event: any) {
    let resourcesUnderResourceType: any[] = this.resourcesDataCopy[resourceType];

    let searchQuery = event.target.value.toLowerCase();

    if (!isNullOrUndefined(resourcesUnderResourceType) && resourcesUnderResourceType.length > 0) {

      if (searchQuery.length > 0) {
        resourcesUnderResourceType = resourcesUnderResourceType
          .filter((resource: any) => resource.resourceName.toLowerCase().includes(searchQuery));

        this.resourcesData[resourceType] = [...resourcesUnderResourceType];
      } else {
        this.resourcesData = { ...this.resourcesDataCopy };
      }
    }
  }

  buildCustomerInfo() {

    if (!isNullOrUndefined(this.customerDetails)) {
      return {
        ...this.customerDetails['info'],
        customerId: this.customerId,
        primaryContact: this.customerDetails['info'].primaryContact,
        secondaryContact: this.customerDetails['info']['secondaryContact']? this.customerDetails['info']['secondaryContact'] : null
      };
    }
  }
}
